// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ChevronRightIcon = /* @__PURE__ */ createIcon(
  'chevron-right',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M8.293 5.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 1 1-1.414-1.414L13.586 12 8.293 6.707a1 1 0 0 1 0-1.414',
      },
    ],
  ]
);
